import type { InvoiceDiscountType } from '@features/invoices/enums/invoiceDiscountType'
import type { InvoiceFormLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormLine'
import type { DepositDeduction } from '@features/invoices/types/invoices/depositDeduction'
import { getInvoiceSummaryTotals } from '@features/invoices/utils/getInvoiceSummaryTotals'
import { hasInvoiceLineDiscount } from '@features/invoices/utils/hasInvoiceLineDiscount'

interface GetCreditNoteOriginalInvoiceGrossTotalOptions {
  currency: string
  depositDeduction?: Pick<DepositDeduction, 'grossTotal'>
  discount: number
  discountType: InvoiceDiscountType
  invoiceLines: InvoiceFormLine[]
  summaryGrossTotal: number
}

// The credit note must cover the final invoice's full line total. The backend rejects the approve
// request when the credit note gross is only the payable amount.
// A final invoice's summary is the line total on some documents and the payable amount on older ones,
// so the cap is taken from the copied lines themselves, with the same discount the form validation applies.
export const getCreditNoteOriginalInvoiceGrossTotal = (
  options: GetCreditNoteOriginalInvoiceGrossTotalOptions,
): number => {
  const { currency, depositDeduction, discount, discountType, invoiceLines, summaryGrossTotal } = options

  if (!depositDeduction) {
    return summaryGrossTotal
  }

  const hasLineDiscount = hasInvoiceLineDiscount(invoiceLines)
  const { grossTotal } = getInvoiceSummaryTotals({
    currency,
    discountType,
    globalDiscount: !hasLineDiscount && discount > 0 ? discount : undefined,
    invoiceLines,
    isCreditNote: true,
  })

  return Math.abs(grossTotal)
}
